
const win = window;
const VideoComponent = require('../../viscomjs/video/VideoComponent');
const SizesUtils = require('../../viscomjs/utils/SizesUtils');

const video = new VideoComponent('video', {
    name: 'bg',
    selector: '.video-bg',
    container: '.video-bg__container--main',
    poster: './img/poster.jpg',
    src: [
        {src: './video/bg.mp4', type: 'video/mp4'},
        {src: './video/bg.webm', type: 'video/webm'}
    ],
    defaultMuted: true,
    playsinline: true,
    loop: true,
    size: 'cover'
});


module.exports.start = () => {
    document.querySelector(video._containerSelector).classList.add('show');
    video.updateOnResize(SizesUtils.winOffsetWidth(), SizesUtils.winOffsetHeight());
    win.addEventListener('resize', () => {
        video.updateOnResize(SizesUtils.winOffsetWidth(), SizesUtils.winOffsetHeight());
    });
    video.start();
}


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/videoBg.js